import {initialYearClassroom} from '../../../../utils/classroomYear'
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import { actionLogin, actionSaveLogin,actionGetStaffLoginInfo } from "../../../../redux/auth";
import { setAuth } from "../core/AuthHelpers";
import { IAuthInfoModel, IClassroom, ILogin } from "../../../../constants";
import { actionGetStaffClassrooms, actionGetStudents, actionSaveSelectedClass } from "../../../../redux/education";
import { actionGetSubUserAvatars } from "../../../../redux/user";
import { actionGetAvatars } from "../../../../redux/content";
import {logEvent} from '../../../../utils/analytics'
import {UiIcon} from '../../../../components/UiIcon'
import {k12AuthAuthorize} from '../../../../services/education/staff.service'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Geçerli bir e-posta adresi girin.')
    .min(3, 'En az 3 karakter girin.')
    .max(50, 'En fazla 50 karakter girebilirsiniz.')
    .required('E-posta adresinizi girin.'),
  password: Yup.string()
    .min(3, 'En az 3 karakter girin.')
    .max(50, 'En fazla 50 karakter girebilirsiniz.')
    .required('Şifrenizi girin.'),
})


export function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [alertStatus, setAlertStatus] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState(false)
  const [k12Loading, setK12Loading] = useState(false)
  const [k12Error, setK12Error] = useState(false)

  const handleK12Login = async () => {
    setK12Loading(true)
    setK12Error(false)
    try {
      window.location.assign(await k12AuthAuthorize())
    } catch {
      setK12Error(true)
      setK12Loading(false)
    }
  }
  let initialValues:ILogin = {
    email: '',
    password: '',
  }

  // Function to get URL parameters
  const getUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return {
      email: urlParams.get('email') || '',
      password: urlParams.get('password') || ''
    }
  }

  // Auto-login function
  const performAutoLogin = async (email: string, password: string) => {
    const loginData: ILogin = { email, password }
    
    dispatch(
      actionLogin(loginData, (a) => {
        if (a.type === 'FAILURE') {
          setAlertStatus(true);
        } else {
          localStorage.clear();
          let userData = a.payload.data;
          dispatch(actionGetStaffLoginInfo(a.payload.data.id,(staffData)=>{
            if (staffData.type==='FAILURE'){
              setAlertStatus(false);
            } else {
              localStorage.clear();
              setAlertStatus(false);
              logEvent("Education", "Login", a?.payload?.data?.id)
              let authPropsData: IAuthInfoModel = {
                staffInfo: Object.assign({ email: userData.email,id:userData.id }, staffData.payload.data),
                authentication: userData.authentication,
                roleId:userData.roleId,
                device:userData.device
              }
              dispatch({type: 'AUTH_RESET_SESSION'})
              dispatch(actionSaveLogin(authPropsData))
              setAuth(authPropsData.authentication)
              dispatch(
                actionGetStaffClassrooms({userId:userData.id},
                  (r) => {
                    if (r.type === 'SUCCESS') {
                      if (r.payload.data.length > 0 ) {
                        let selectedClassroom : IClassroom = initialYearClassroom(r.payload.data);
                        dispatch(actionSaveSelectedClass(selectedClassroom))
                        if (!selectedClassroom.id) return
                        dispatch(actionGetStudents({classroomId:selectedClassroom.id},(r)=>{
                          if (r.type === "SUCCESS"){
                            let userIds = r.payload.data.map((item:any)=>item.subUserId);
                            dispatch(actionGetSubUserAvatars({ids:JSON.stringify(userIds)}))
                            dispatch(actionGetAvatars({}))
                          }
                        }))
                      }
                    }
                  }
                )
              )
              localStorage.setItem('app-version', '102')
              navigate('/dashboard', {replace: true})
            }
          }));
        }
      })
    )
  }

  // Check for URL parameters on component mount
  useEffect(() => {
    const { email, password } = getUrlParams()
    if (email && password) {
      performAutoLogin(email, password)
    }
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setAlertStatus(false)
      dispatch(
        actionLogin(values, (a) => {
          if (a.type === 'FAILURE') {
            setAlertStatus(true);
            setStatus(a.payload?.data.message)
            setSubmitting(false)
          } else {
            localStorage.clear();
            let userData = a.payload.data;
            dispatch(actionGetStaffLoginInfo(a.payload.data.id,(staffData)=>{
              if (staffData.type==='FAILURE'){
                setAlertStatus(true);
                setSubmitting(false)
              } else {
                localStorage.clear();
                setAlertStatus(false);
                setSubmitting(false);
                logEvent("Education", "Login", a?.payload?.data?.id)
                let authPropsData: IAuthInfoModel = {
                  staffInfo: Object.assign({ email: userData.email,id:userData.id }, staffData.payload.data),
                  authentication: userData.authentication,
                  roleId:userData.roleId,
                  device:userData.device
                }
                dispatch({type: 'AUTH_RESET_SESSION'})
                dispatch(actionSaveLogin(authPropsData))
                setAuth(authPropsData.authentication)
                dispatch(
                  actionGetStaffClassrooms({userId:userData.id},
                    (r) => {
                      if (r.type === 'SUCCESS') {
                        if (r.payload.data.length > 0 ) {
                          let selectedClassroom : IClassroom = initialYearClassroom(r.payload.data);
                          dispatch(actionSaveSelectedClass(selectedClassroom))
                          if (!selectedClassroom.id) return
                          dispatch(actionGetStudents({classroomId:selectedClassroom.id},(r)=>{
                            if (r.type === "SUCCESS"){
                              let userIds = r.payload.data.map((item:any)=>item.subUserId);
                              dispatch(actionGetSubUserAvatars({ids:JSON.stringify(userIds)}))
                              dispatch(actionGetAvatars({}))
                            }
                          }))
                        }
                      }
                    }
                  )
                )
                localStorage.setItem('app-version', '102')
                navigate('/dashboard', {replace: true})
              }
            }));
          }
        })
      )
    },
  })

  return (
    <form className='auth-login-form' onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form' aria-labelledby='login-title'>
      <div className='auth-form-heading'>
        <span className='auth-form-eyebrow'>HOŞ GELDİNİZ</span>
        <h1 id='login-title'>Öğretmen girişi</h1>
        <p>Sınıfınızın okuma yolculuğuna<br className='auth-desktop-break'/> kaldığınız yerden devam edin.</p>
      </div>
      {alertStatus && <div className='auth-login-error' role='alert'><UiIcon name='info' size={19}/><span>Giriş tamamlanamadı. E-posta ve şifrenizi kontrol edip tekrar deneyin.</span></div>}
      <div className='auth-field'>
        <label htmlFor='login-email'>E-posta adresi</label>
        <div className='auth-input-wrap'>
          <UiIcon name='mail' size={19}/>
          <input
            {...formik.getFieldProps('email')}
            id='login-email'
            className='auth-input'
            type='email'
            placeholder='ornek@okul.com'
            autoComplete='username'
            autoCapitalize='none'
            spellCheck={false}
            aria-invalid={Boolean(formik.touched.email && formik.errors.email)}
            aria-describedby={formik.touched.email && formik.errors.email ? 'login-email-error' : undefined}
          />
        </div>
        {formik.touched.email && formik.errors.email && <p className='auth-field-error' id='login-email-error' role='alert'>{formik.errors.email}</p>}
      </div>
      <div className='auth-field'>
        <label htmlFor='login-password'>Şifre</label>
        <div className='auth-input-wrap'>
          <UiIcon name='lock' size={19}/>
          <input
            {...formik.getFieldProps('password')}
            id='login-password'
            className='auth-input auth-password-input'
            type={showPassword ? 'text' : 'password'}
            placeholder='Şifrenizi girin'
            autoComplete='current-password'
            aria-invalid={Boolean(formik.touched.password && formik.errors.password)}
            aria-describedby={formik.touched.password && formik.errors.password ? 'login-password-error' : undefined}
          />
          <button type='button' className='auth-password-toggle' aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'} aria-pressed={showPassword} aria-controls='login-password' onClick={() => setShowPassword(value => !value)}><UiIcon name={showPassword ? 'eye-off' : 'eye'} size={20}/></button>
        </div>
        {formik.touched.password && formik.errors.password && <p className='auth-field-error' id='login-password-error' role='alert'>{formik.errors.password}</p>}
      </div>
      <button type='submit' id='kt_sign_in_submit' className='auth-submit' disabled={formik.isSubmitting || k12Loading} aria-busy={formik.isSubmitting}>
        {formik.isSubmitting ? <><span className='spinner-border spinner-border-sm' aria-hidden='true'/>Giriş yapılıyor…</> : <>Giriş yap<UiIcon name='arrow-right' size={19}/></>}
      </button>
      <div className='auth-login-divider'><span>veya</span></div>
      <button type='button' className='auth-k12-button' onClick={handleK12Login} disabled={formik.isSubmitting || k12Loading} aria-busy={k12Loading} aria-describedby={k12Error ? 'k12-login-error' : undefined}>
        {k12Loading ? <><span className='spinner-border spinner-border-sm' aria-hidden='true'/>K12’ye yönlendiriliyor…</> : <><span className='auth-k12-mark' aria-hidden='true'>K12</span><span>K12 ile giriş yap</span><UiIcon name='arrow-right' size={18}/></>}
      </button>
      {k12Error && <p id='k12-login-error' className='auth-field-error' role='alert'>K12 giriş sayfası açılamadı. Lütfen tekrar deneyin.</p>}
      <div className='auth-help'><span>Giriş yapmakta zorlanıyor musunuz?</span><a href='https://gokidly.com/#contact' target='_blank' rel='noopener noreferrer'>Bizimle iletişime geçin<UiIcon name='external' size={13}/></a></div>
    </form>
  )
}
